import * as React from "react";
import { cn } from "@/lib/utils";
import { Container } from "./Container";

type SectionProps = React.PropsWithChildren<
  {
    className?: string;
    containerClassName?: string;
    fullBleed?: boolean;
  } & React.HTMLAttributes<HTMLElement>
>;

export function Section({
  children,
  className,
  containerClassName,
  fullBleed = false,
  ...props
}: SectionProps) {
  if (fullBleed) {
    return (
      <section className={cn("py-16 sm:py-20", className)} {...props}>
        {containerClassName ? (
          <Container className={containerClassName}>{children}</Container>
        ) : (
          children
        )}
      </section>
    );
  }

  return (
    <section className={cn("py-16 sm:py-20", className)} {...props}>
      <Container className={containerClassName}>{children}</Container>
    </section>
  );
}
